




















import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import { ErrorManager } from '@/models/error';

export default Vue.extend({
  name: 'QuotePaymentTermCodePicker',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: [Number, Object],

    externalErrorMessage: {
      type: Array as PropType<string[]>,
      default: () => []
    }
  },

  data() {
    return {
      lazyValue: this.value,
      errorMessage: '',
      loading: false
    };
  },

  watch: {
    value: {
      handler(val: number) {
        this.lazyValue = val;
      },
      immediate: true
    }
  },

  computed: {
    ...mapGetters({
      quotePaymentTermCodes: 'quotePaymentTermCode/getQuotePaymentTermCodes'
    }),

    internalValue: {
      get(): number {
        return this.lazyValue;
      },
      set(val: number) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    },

    errorMessageList(): string[] {
      let errorList: string[] = [];
      if (this.externalErrorMessage) {
        errorList = this.externalErrorMessage;
      }
      if (this.errorMessage) {
        errorList.push(this.errorMessage);
      }

      return errorList;
    }
  },

  mounted() {
    this.loadQuotePaymentTermCodes();
  },

  methods: {
    ...mapActions({
      fetchQuotePaymentTermCodes:
        'quotePaymentTermCode/fetchQuotePaymentTermCodes'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.$emit('clearAllErrors');
    },

    loadQuotePaymentTermCodes() {
      this.clearAllErrors();
      this.loading = true;
      this.fetchQuotePaymentTermCodes()

        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
});
